/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import AppConstant from '../constants/app.constant';
import reportError from './error-handler/reportError';
import LZString from 'lz-string';

const elevationHistoryKey = AppConstant.localstorageConf.prefix + 'elHist';
const prefixElevation = AppConstant.localstorageConf.prefix + 'el_';

/**
 * Clear old records if record last used was 30days back
 */
const clearOldElevationRecords = () => {
  try {
    const elevationHistoryValue = localStorage.getItem(elevationHistoryKey);
    if (!elevationHistoryValue) {
      return
    }
    const elevationHistory = JSON.parse(elevationHistoryValue);
    const keysOfHistory = Object.keys(elevationHistory);
    keysOfHistory.forEach((item) => {
      const diffTime = Math.abs(Date.now() - elevationHistory[item].lastUsed);
      const diffInDays = diffTime / (1000 * 60 * 60 * 24);
      if (diffInDays > 30) {
        localStorage.removeItem(elevationHistory[item].key);
      }
    });
  }
  catch (ex) {
    console.log(ex);
    reportError(ex);
  }
};

/**
 *
 * @param {string} key
 */
const saveElevationRecordsHistory = (key) => {
  try {
    let elevationHistoryValue = localStorage.getItem(elevationHistoryKey);
    let elevationHistory;
    if (!elevationHistoryValue) {
      elevationHistory = {};
    }
    else {
      elevationHistory = JSON.parse(elevationHistoryValue);
    }
    if (!elevationHistory[key]) {
      elevationHistory[key] = {
        key,
        lastUsed: Date.now(),
      };
    } else {
      elevationHistory[key].lastUsed = Date.now();
    }
    localStorage.setItem(elevationHistoryKey, JSON.stringify(elevationHistory));
    clearOldElevationRecords();
  } catch (ex) {
    console.log(ex);
    reportError(ex);
  }
};

/**
 *
 * @param {string} key
 */
function getKeyElevation(key) {
  const keyValue = prefixElevation + key;
  return keyValue;
}

/**
 * Get data from localstorage and save
 * @param {string} key
 */
const getElevationFromLocalstorage = (key) => {
  try {
    const elevationValue = localStorage.getItem(getKeyElevation(key));
    if (!elevationValue) {
      return null;
    }
    const unparsedElevationData = LZString.decompress(elevationValue);
    const elevationData = JSON.parse(unparsedElevationData);
    if (elevationData) {
      saveElevationRecordsHistory(getKeyElevation(key));
    }
    return elevationData;
  }
  catch (ex) {
    console.log(ex);
    reportError(ex);
    return null;
  }
};

/**
 * Set data to localstorage
 * @param {string} key
 * @param {Object} value
 */
const setElevationToLocalstorage = (key, value) => {
  try {
    //debugger    
    localStorage.setItem(getKeyElevation(key), LZString.compress(JSON.stringify(value)));
    saveElevationRecordsHistory(getKeyElevation(key));
  }
  catch (ex) {
    console.log(ex);
    reportError(ex);
    return null;
  }
};

export { getElevationFromLocalstorage, setElevationToLocalstorage };
